export const FilterIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.00257 16C6.71996 16 6.48307 15.9042 6.2919 15.7125C6.10072 15.5208 6.00513 15.2833 6.00513 15V9L0.220022 1.6C-0.0293364 1.26667 -0.0667399 0.916667 0.107811 0.55C0.282362 0.183334 0.585748 0 1.01797 0H14.982C15.4143 0 15.7176 0.183334 15.8922 0.55C16.0667 0.916667 16.0293 1.26667 15.78 1.6L9.99487 9V15C9.99487 15.2833 9.89928 15.5208 9.7081 15.7125C9.51693 15.9042 9.28004 16 8.99743 16H7.00257Z"
      fill="#2B2A29"
    />
  </svg>
)
